export enum EV4bErrorCode {
  // programs
  ACTIVE_PROGRAMS_CANNOT_BE_DELETED = "ACTIVE_PROGRAMS_CANNOT_BE_DELETED",
  DUPLICATE_PROGRAM_NAME_FOR_SAME_SITE = "DUPLICATE_PROGRAM_NAME_FOR_SAME_SITE",

  // account/login
  USER_ACCOUNT_ALREADY_ACTIVATED = "USER_ACCOUNT_ALREADY_ACTIVATED",
  ACTIVATION_CODE_EXPIRED = "ACTIVATION_CODE_EXPIRED",
  RECOVERY_CODE_EXPIRED = "RECOVERY_CODE_EXPIRED",

  // form
  EMAIL_ADDRESS_INVALID_FORMAT = "EMAIL_ADDRESS_INVALID_FORMAT",
  PHONE_NUMBER_INVALID_FORMAT = "PHONE_NUMBER_INVALID_FORMAT",
  INTEGER_INVALID_VALUE = "INTEGER_INVALID_VALUE",
  INTEGER_NEGATIVE = "INTEGER_NEGATIVE",
  INVALID_VALUE = "INVALID_VALUE",
  IS_BLANK = "IS_BLANK",
  IS_EMPTY = "IS_EMPTY",
  NOT_STRONG_ENOUGH_PASSWORD = "NOT_STRONG_ENOUGH_PASSWORD",
  STRING_MAX_SIZE_EXCEEDED = "STRING_MAX_SIZE_EXCEEDED",
  STRING_MIN_SIZE_NOT_REACHED = "STRING_MIN_SIZE_NOT_REACHED",
  STRING_WRONG_FIXED_SIZE = "STRING_WRONG_FIXED_SIZE",
  UNEXPECTED_VALUE = "UNEXPECTED_VALUE",
  WRONG_STRING_CODE_FORMAT = "WRONG_STRING_CODE_FORMAT",
  WRONG_STRING_NAME_FORMAT = "WRONG_STRING_NAME_FORMAT",
  WRONG_STRING_RELAXED_NAME_FORMAT = "WRONG_STRING_RELAXED_NAME_FORMAT",

  // section
  SITE_SECTION_ALREADY_EXISTS_WITH_SAME_NAME = "SITE_SECTION_ALREADY_EXISTS_WITH_SAME_NAME",
  SITE_SECTION_CATEGORY_NAME_EXISTS_ON_SITE = "SITE_SECTION_CATEGORY_NAME_EXISTS_ON_SITE",
}

export enum EV4bClientErrorCategory {
  DOMAIN_ERROR = "DOMAIN_ERROR",
  FORM_VALIDATION_ERROR = "FORM_VALIDATION_ERROR",
  HTTP_READ_ERROR = "HTTP_READ_ERROR",
  TECHNICAL_ERROR = "TECHNICAL_ERROR",
  UNEXPECTED_ERROR = "UNEXPECTED_ERROR",
}
